
<script>
	export default {
		data() {
			return {
				url: ""
			}
		},
		watch: {
			$route: {
				handler: function (value) {
					this.url = value.path;		
				},
				immediate: true,
			}
		}
	}
</script>

<template>
<div>
	<template v-if="url === '/inicio'">
		<svg class="platform platform-background platform-background-home" xmlns="http://www.w3.org/2000/svg" width="398.05" height="401.033" viewBox="0 0 398.05 401.033">
			<path class="color-main" d="M367.711,294.182a196.9,196.9,0,0,1-71.629,70.882Q250.968,391.2,197.12,391.229q-53.845,0-98.916-26.165a196.446,196.446,0,0,1-71.648-70.882Q-.025,249.425,0,196.37q0-53.816,26.555-98.936c.9-1.54,1.9-2.993,2.834-4.5L.986,19.264A14.134,14.134,0,0,1,19.969,1.286L88.577,32.154c3.145-2.061,6.336-4.077,9.627-5.986Q143.279.024,197.12,0q53.845,0,98.962,26.164a195.907,195.907,0,0,1,71.629,71.265q26.541,45.094,26.554,98.936Q394.265,249.452,367.711,294.182ZM197.133,89.485A106.131,106.131,0,1,0,303.264,195.616,106.125,106.125,0,0,0,197.133,89.485Z" transform="matrix(-0.017, -1, 1, -0.017, 6.881, 401.033)"/>
		</svg>
	</template>

	<template v-else>
		<svg class="platform platform-background platform-background-module" xmlns="http://www.w3.org/2000/svg" width="241.5" height="60" viewBox="0 0 241.5 60">
			<g class="color-main" transform="translate(197.854 -1010.525)">
				<ellipse cx="30" cy="30" rx="30" ry="30" transform="translate(-197.854 1010.525)"/>
				<ellipse cx="30" cy="30" rx="30" ry="30" transform="translate(-107.104 1010.525)"/>
				<ellipse cx="30" cy="30" rx="30" ry="30" transform="translate(-16.354 1010.525)"/>
			</g>
		</svg>
	</template>
</div>
</template>